<template>
  <div>
    <el-dialog title="需求详情" :visible.sync="visible" :close-on-click-modal="false" width="600px"
      class="ecology-notice-detail" @close="onClose">
      <div class="content" v-loading="isLoading">
        <div class="p-y-10">
          <div class="between mb-16">
            <div class="title">{{ dataSource.projectName }}</div>
            <div class="ml-8">
              <!--  1- 已接单, 2- 已完成, 3- 已过期, -->
              <span class="tag1" v-if="dataSource.ssoDemandStatus == 1">已接单</span>
              <span class="tag2" v-if="dataSource.ssoDemandStatus == 2">已完成</span>
              <span class="tag3" v-else-if="dataSource.ssoDemandStatus == 3">已过期</span>
            </div>
          </div>
          <div class="info">
            <div>
              <span class="label">外包类型：</span><span class="value">{{ dataSource.outSourceTypeStr }}</span>
            </div>
            <div>
              <span class="label">服务开始时间：</span><span class="value">{{ dataSource.startTime }}</span>
            </div>
            <div>
              <span class="label">服务结束时间：</span><span class="value">{{ dataSource.endTime }}</span>
            </div>
            <div>
              <span class="label">合计天数：</span><span class="value">{{ dataSource.allDays }}</span>
            </div>
            <div>
              <span class="label">服务地址：</span><span class="value">{{ dataSource.serviceLocation }}</span>
            </div>
            <div>
              <span class="label">备注：</span><span class="value">{{ dataSource.note }}</span>
            </div>
            <div>
              <span class="label">申请金额：</span><span class="value">{{ dataSource.totalAmount }}</span>
            </div>
            <div>
              <span class="label">公告有效期至：</span><span class="value">{{ dataSource.validityPeriod }}</span>
            </div>
            <div class="flex">
              <span class="label">附件：</span>
              <div>
                <div v-for="item in dataSource.attachment || []" :key="item.ossId">
                  <a :href="item.url" target="_blank">{{ item.fileName }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataSource: {},
      visible: false,
      isLoading: false,
    };
  },
  methods: {
    onShow(res) {
      this.visible = true;
      this.getDatail(res.id)
    },
    onClose() {
      this.visible = false
    },
    getDatail(id) {
      this.isLoading = true;
      this.$http.post(`/front/oms/omsSsoDemand/getOne`, { id }).then(({ data: res }) => {
        if (res.code == 0) {
          this.dataSource = res.data;
        }
      }).finally(() => {
        this.$nextTick(() => {
          this.isLoading = false;
        })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  //   height: 640px;
  overflow: auto;
  padding: 20px 30px;
}

.p-y-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.flex {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  max-width: 470px;
}

.txt {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
}

.label {
  @extend .txt;
  color: #666666;
  width: 100px;
  display: inline-block;
  text-align: right;
}

.value {
  @extend .txt;
  font-weight: 600;
  color: #333333;
}

.ml-8 {
  margin-left: 8px;
}

.tag {
  @extend .txt;
  color: #ffffff;
  display: inline-block;
  height: 20px;
  line-height: 16px;
  border-radius: 10px;
  padding: 2px 8px;
}

.tag1 {
  @extend .tag;
  background: #1fbd13;
}

.tag2 {
  @extend .tag;
  background: #2a54d1;
}

.tag3 {
  @extend .tag;
  background: #ccc;
}

.b-line {
  border-bottom: 1px solid #eeeeee;
}

.flex-line-center {
  display: flex;
  align-items: center;
}

.mb-16 {
  margin-bottom: 16px;
}

a {
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  color: #2a54d1;
  margin-bottom: 10px;
}

.info {
  &>div {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.ecology-notice-detail {
  .el-dialog__header {
    box-shadow: inset 0px -1px 0px 0px #e1e3e5;
  }

  .el-dialog__title {
    font-family: Alibaba PuHuiTi;
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .el-icon-close {
    color: #333;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>